var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { SteemActionType } from '@popup/steem/actions/action-type.enum';
import CurrencyPricesUtils from '@popup/steem/utils/currency-prices.utils';
import Logger from 'src/utils/logger.utils';
export const loadCurrencyPrices = () => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const prices = yield CurrencyPricesUtils.getPrices();
        dispatch({
            type: SteemActionType.LOAD_CURRENCY_PRICES,
            payload: prices,
        });
        dispatch({
            type: SteemActionType.SET_APP_STATUS,
            payload: { priceLoaded: true },
        });
    }
    catch (e) {
        Logger.error('currency price error', e.toString());
    }
});
